<div class="background">

  <div class="login-panel">

    <img class="logo" [src]="settingsManagerService.getLogo(false)" alt="Scotty Expert">

    <!-- Name -->
    <mat-form-field class="input">
      <mat-label>Name</mat-label>
      <input matInput type="text" [(ngModel)]="name">
    </mat-form-field>

    <!-- Surname -->
    <mat-form-field class="input">
      <mat-label>Surname</mat-label>
      <input matInput type="text" [(ngModel)]="surname">
    </mat-form-field>

    <!-- Access code -->
    <mat-form-field class="input">
      <mat-label>Access code</mat-label>
      <input matInput type="password" [(ngModel)]="accessCode">
    </mat-form-field>

    <!-- Access button -->
    <button class="login-button" mat-raised-button color="primary" (click)="access()" [disabled]="!valid()">Access training session</button>

    <!-- Wrong access code -->
    <span *ngIf="error" class="error">
      <mat-icon>close</mat-icon>
      Wrong access code. Try again.
    </span>

  </div>

  <!-- by Wideverse -->
  <img class="byWideverse" src="assets/img/byWideverse.png" alt="Wideverse">

</div>
